// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"f42dc8a7","451":"7a3b1c82","487":"8f729772","567":"ac94ac9c","788":"a85373b1"}[chunkId] + ".chunk.css";
};